// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.3014 8.11756L12.1624 19.2122L6.74553 18.5154L3.07315 22.1878L1.65894 20.7736L5.32764 17.1049L4.58572 11.6948L15.6715 0.563965L17.4882 6.35116L23.3014 8.11756Z"}}]};

const PenQuillFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pen-quill-filled',
    ref,
    icon: element,
  },
));

PenQuillFilledIcon.displayName = 'PenQuillFilledIcon';

export default PenQuillFilledIcon;
